export default __webpack_public_path__ + "static/logo-dark-9089b5b31934a10e6bf933562ab86958.svg";